import UserService from '../service/User';

export const isLogin = () => {
  if (localStorage.getItem('accessToken')) {
    return true;
  } else {
    return false;
  }
};

export const userGradeType = async () => {
  const userData = await UserService.userInfo();
  return userData.data.plan_grade;
};

export const userRegion = async () => {
  const userData = await UserService.userInfo();
  const regionCode = userData?.data.plan_region.split(',');

  const regionMap: Record<string, string> = {
    A: '전국',
    B: '서울/수도권',
    C: '지역구 통합',
    D: '대전/충청권',
    E: '강원도권',
    F: '경상권',
    G: '광주/전라권',
    H: '제주',
  };

  const regions = regionCode.map((code: string) => regionMap[code]);

  return regions;
};
